import React from "react";
import { getCurrentTimePosition } from "./helpers";

const classes = {
  Wrapper: "absolute left-3 right-0 h-0.5 bg-red-500 flex items-center",
  Line: "absolute left-0 w-3 h-3 rounded-full bg-red-500"
};

export interface CurrentTimeLineProps {
  timeZone?: string;
}

export const CurrentTimeLine: React.FC<CurrentTimeLineProps> = ({
  timeZone
}) => {
  const [position, setPosition] = React.useState(
    getCurrentTimePosition(timeZone)
  );

  React.useEffect(() => {
    // Update position every minute
    const interval = setInterval(() => {
      setPosition(getCurrentTimePosition(timeZone));
    }, 60000);

    return () => clearInterval(interval);
  }, [timeZone]);

  return (
    <div className={classes.Wrapper} style={{ top: `${position}px` }}>
      <div className={classes.Line} />
    </div>
  );
};
